import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img       } from '../../Components/UI/UI'

import {getWeather} from '../../Utility/Utility'

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
        <Menu />
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
            
            <div className="container">
             
             
          <p>În aceste vremuri provocatoare, noi, cei din Israel, suntem alături de voi, românii, rugându-ne pentru voi și oferindu-vă sprijinul nostru, în speranța unui viitor mai bun.</p>
               

             {/*<h1>INFORMAȚII PRIVIND ALERTELE DE CĂLĂTORIE ȘI SECURITATEA ÎN ISRAEL</h1>*/}

             <h2 className="ac-pink">INFORMAȚII RECENTE DESPRE CORONAVIRUS (COVID-19) PENTRU TURIȘTII CARE PLEACĂ ÎN ISRAEL (COVID-19):</h2>
             
             {/*<h2 className="ac-pink ac-margin-top-1 ac-bigger">Israel anunță noi măsuri de relaxare</h2>
             
             <p>Începând cu 1 iunie, Ministerul Sănătății din Israel a anunțat o altă serie de măsuri de relaxare, printre care și deschiderea de restaurante, atracții turistice și hoteluri.</p>
             
             <p>Plajele au fost deschise pe 20 mai, în timp ce restaurantele, barurile, puburile și cluburile au fost deschise pe 27 mai. Toate spațiile publice funcționează sub rezerva unor restricții. Atracțiile turistice și de agrement, cum ar fi hotelurile, muzeele și bazinele de înot, sunt de asemenea deschise, sub rezerva unor restricții.</p>
             
             <p>Ministerul Sănătății a convenit să crească numărul maxim de călători permis în călătoriile cu autobuzul și taxiul, precum și reluarea activității trenurilor, începând cu 8 iunie.</p>*/}
             
             <h2 className="ac-pink ac-margin-top-1 ac-bigger">Turiștii care doresc să călătorească în Israel:</h2>

             <p>För tillfället, och tills vidare, kommer alla som inte är invånare i Israel eller israeliska medborgare att nekas inträde i landet oavsett varifrån man reser. I undantagsfall kan man ansöka om utrikesministeriets godkännande om att få resa in i landet, men man måste då kunna intyga att man kommer isolera sig i 14 dagar.</p>
             
             <ul>
              <li>
              <strong className="ac-pink">Este absolut interzis să intrați în clinici sau spitale dacă prezentați oricare dintre simptomele de mai sus!</strong>
              </li>
            </ul>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Orientări generale pentru toți cei care stau în Israel:</h2>

            <ul>
              <li>
                Pentru informații recente privind cazurile de Coronavirus din Israel, vă rugăm să consultați notificările Departamentului de Sănătate pe <a href="https://govextra.gov.il/ministry-of-health/corona/corona-virus-en/" target="_blank">site-ul web</a>.
              </li>
              <li>
                Guvernul israelian monitorizează îndeaproape epidemia și a implementat măsuri temporare, inclusiv restricții la frontieră pentru călătorii din întreaga lume.
              </li>
              <li>
                Persoanele care prezintă simptome nu au voie să însoțească pacienții sau să viziteze unități de îngrijire a persoanelor vârstnice.
              </li>
            </ul>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Important!</h2>

            <ul>
              <li>
                Dacă vi s-a solicitat să vă autoizolați, <strong className="ac-pink">trebuie să raportați acest lucru Ministerului Sănătății: <a href="www.govforms.gov.il" target="_blank">www.govforms.gov.il/</a></strong>
              </li>
              <li>
                Dacă dezvoltați o febră de 38 °C sau mai mare, tuse, respirație dificilă sau alte simptome respiratorii, <strong className="ac-pink">trebuie să intrați imediat în autoizolare și să apelați linia telefonică a Serviciul de urgență 101 MDA pentru sfaturi medicale.</strong>
              </li>
            </ul>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Întrebări frecvente</h2>

            <ol className="ac-padding-start-0">
              <li>
              <strong className="ac-pink">Sunt turist în Israel și sunt îngrijorat că pot avea COVID-19, unde ar trebui să mă duc?</strong>           
              Dacă aveți o febră de 38 °C sau mai mare, tuse, respirație dificilă sau alte simptome respiratorii, trebuie să intrați imediat în autoizolare și să apelați linia telefonică a Serviciul de urgență 101 MDA pentru sfaturi medicale. <strong class="ac-pink">Nu mergeți la nicio clinică medicală sau la niciun cabinet de urgență.</strong>
              </li> 
              <li><strong className="ac-pink">Când va fi Israelul deschis din nou pentru vizitatorii care vor să intre?</strong></li>
              <li>În acest moment, nu există o dată cunoscută în care Israel va fi deschis pentru vizitatorii care vor să intre în țară.</li>
            </ol>





          <Img desktopImg={"infection.jpg"} />

          </div>

          
        <Footer />
      </div>
    )
    }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirusRO.js